import { render, staticRenderFns } from "./DocTxtFileViewer.vue?vue&type=template&id=1b3ca19e&scoped=true&"
import script from "./DocTxtFileViewer.vue?vue&type=script&lang=js&"
export * from "./DocTxtFileViewer.vue?vue&type=script&lang=js&"
import style0 from "./DocTxtFileViewer.vue?vue&type=style&index=0&id=1b3ca19e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3ca19e",
  null
  
)

export default component.exports
import {QIcon,QTooltip,QInnerLoading,QSpinnerGears} from 'quasar'
component.options.components = Object.assign({QIcon,QTooltip,QInnerLoading,QSpinnerGears}, component.options.components || {})
